import React from 'react';

const Contact = () => {

    return (
        <section id="contact" className="section">
            <div className="container">
                <h2 className="section-title">Contact Us</h2>

                <div className="contact-layout">
                    {/* Map Section */}
                    <div className="map-section">
                        <div className="map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5862.461989796919!2d80.19506169140216!3d12.991511763440474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267d39e99ff63%3A0x6888d2de94c16629!2sGayathri%20D&#39;s%20SriChem%20-%20Chemistry%20Tution%20Centre!5e0!3m2!1sen!2sin!4v1760281485541!5m2!1sen!2sin"
                                className="map-iframe"
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Tuition Center Location"
                            ></iframe>

                        </div>
                    </div>


                    {/* Contact Info Section */}
                    <div className="contact-info-section">
                        <div className="contact-header">
                            <h3>Get In Touch</h3>
                        </div>

                        <div className="contact-grid">
                            <div className="contact-card">
                                <div className="contact-icon">📍</div>
                                <div className="contact-details">
                                    <h4>Address</h4>
                                    <p> <strong>SriChem Tuition Center</strong>
                                        <br></br>
                                        <strong>1st Floor (Above Post Office)</strong>
                                        <br></br>
                                        8/9, 21st Street, Thillaiganga Nagar
                                        Nanganallur
                                        <br></br>
                                        Chennai - 600061
                                        <br></br>
                                        Tamil Nadu, India</p>
                                </div>
                            </div>

                            <div className="contact-card">
                                <div className="contact-icon">📞</div>
                                <div className="contact-details">
                                    <h4>Phone</h4>
                                    <p>Ms. Gayathri D - +91 97908 85125</p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;